import type { Booking } from '@/entities/bookings/booking.entity';
import { BookingStatus } from '@/entities/bookings/booking-status.enum';
import { InvoicingType } from '@/entities/bookings/invoicing-type.enum';
import { CounterpartyType } from '@carvia/ros-client-types';

export const PRICE_CHANGE_TOLERANCE = 0.05;

export const isAgencyPriceSplitBooking = (booking: Booking) =>
  booking.invoicingType === InvoicingType.AGENCY ||
  booking.invoicingType === InvoicingType.AGENCY_BULK;

export const isCustomerPaidBooking = (booking: Booking) =>
  booking.invoicingType === InvoicingType.REGULAR ||
  booking.invoicingType === InvoicingType.COMMISSION ||
  booking.invoicingType === InvoicingType.COMPANY_REGULAR;

export const hasBookingPriceChanged = (oldTotalPrice: number, newTotalPrice: number) =>
  Math.abs(newTotalPrice - oldTotalPrice) > PRICE_CHANGE_TOLERANCE;

export const isAtLeastHandedOver = (booking: Booking) =>
  booking.status === BookingStatus.HANDED_OVER ||
  booking.status === BookingStatus.CAR_RETURNED ||
  booking.status === BookingStatus.FINALIZED;

export const getDefaultPriceDifferenceCounterparty = (booking: Booking) =>
  isAtLeastHandedOver(booking) ? CounterpartyType.CUSTOMER : CounterpartyType.AGENCY;

export const requiresPriceDifferenceCounterparty = (booking: Booking, priceChanged: boolean) =>
  priceChanged && (isCustomerPaidBooking(booking) || isAgencyPriceSplitBooking(booking));
